const providerRoutes = [
  {
    path: "/providers",
    component: () =>
      import(
        /* webpackChunkName: "providers" */ "../layouts/ProviderLayout.vue"
      ),
    children: [
      {
        path: "/providers",
        name: "providers",
        component: () =>
          import(
            /* webpackChunkName: "providers" */ "../components/providers/ProviderDoctorList.vue"
          ),
      },
      {
        path: "/providers/create",
        name: "providers-create",
        component: () =>
          import(
            /* webpackChunkName: "providers" */ "../components/user/UserDetail.vue"
          ),
        meta: { providerMode: true },
      },
      {
        path: "/providers/:id",
        name: "providers-edit",
        component: () =>
          import(
            /* webpackChunkName: "providers" */ "../components/user/UserDetail.vue"
          ),
        meta: { providerMode: true },
      },
    ],
  },
];

export default providerRoutes;
